import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { setOpenDialog, setDialogContent } from '../../redux/traffic-prediction';
var t = i18n.getFixedT(null, 'traffic-prediction');
var MapAnalyticsMarkers = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      markerList = _useSelector.trafficPrediction.markerList;

  var dispatch = useDispatch();
  var markersLayerGroup = useRef();
  var map = useMap();
  var iconsUrlObj = {
    'terminal': '/images/icon/icon-terminal-select.png',
    'gate': '/images/icon/icon-gate-select.png',
    'event': '/images/icon/icon-alert-select.png',
    'vd': '/images/icon/icon-car-select.png'
  };

  var clearAllMarkers = function clearAllMarkers() {
    if (!markersLayerGroup.current) return;
    markersLayerGroup.current.clearLayers();
    markersLayerGroup.currnt = null;
  };

  var renderMarkerTooltip = function renderMarkerTooltip(makrerData) {
    switch (makrerData.dataType) {
      case 'event':
        return "<div>\n                    <p style=\"margin: unset\">".concat(makrerData.type, "</p>\n                    <p style=\"margin: unset\">").concat(makrerData.beginTime, "</p>\n                </div>");

      case 'vd':
        return "<div class='title'>".concat(t('lbl-live-traffic'), "</div>\n                    <div class='content-row'>\n                        <img src=").concat(contextRoot, "/images/icon/icon-ic-speed.png />\n                        <span>").concat(_.isNumber(makrerData.speed) && Number(makrerData.speed) > -1 ? t('lbl-speed-tooltip', {
          speed: makrerData.speed
        }) : t('lbl-no-data'), "</span>\n                    </div>");

      case 'terminal':
        return "<div class='title'>".concat(makrerData.name, "</div>\n                    <div class='content-row'>\n                        <img src=").concat(contextRoot, "/images/icon/icon-ic-car.png />\n                        <span>").concat(Number(makrerData.trailerLineQty) > -1 ? t('lbl-vehicles', {
          vehicles: makrerData.trailerLineQty
        }) : t('lbl-no-data'), "</span>\n                    </div>\n                    <div class='content-row'>\n                        <img src=").concat(contextRoot, "/images/icon/icon-ic-time.png />\n                        <span>").concat(Number(makrerData.estLineDuration) > -1 ? t('lbl-minutes', {
          minutes: makrerData.estLineDuration
        }) : t('lbl-no-data'), "</span>\n                    </div>");

      case 'gate':
        return "<div class='title'>".concat(makrerData.name, "</div>\n                    <div class='content-row'>\n                        <img src=").concat(contextRoot, "/images/icon/icon-ic-time.png />\n                        <span>").concat(Number(makrerData.estVisitDuration) > -1 ? t('lbl-minutes', {
          minutes: makrerData.estVisitDuration
        }) : t('lbl-no-data'), "</span>\n                    </div>");

      default:
        return null;
    }
  };

  useEffect(function () {
    clearAllMarkers();
    markersLayerGroup.current = new L.layerGroup();
    var markerClusterGroup = new L.MarkerClusterGroup({
      showCoverageOnHover: false,
      spiderfyDistanceMultiplier: 2,
      maxClusterRadius: function maxClusterRadius() {
        return 40;
      },
      iconCreateFunction: function iconCreateFunction(cluster) {
        return L.divIcon({
          html: "<span>".concat(cluster.getChildCount(), "</span>"),
          className: cx('marker-cluster'),
          iconSize: L.point(30, 30, true)
        });
      }
    });

    var markersData = _.filter(markerList, function (el) {
      return el.longitude && el.latitude;
    });

    var newMarkers = _.map(markersData, function (el) {
      var iconUrl = "".concat(contextRoot).concat(iconsUrlObj[el.dataType]);
      var level = el.congestionStatus ? "level".concat(el.congestionStatus) : '';
      var markerIcon = L.divIcon({
        className: cx('its-marker', level),
        html: "<img class=\"icon\" src=".concat(iconUrl, " width=\"20\" height=\"20\" />"),
        iconSize: [26, 26],
        iconAnchor: [18, 26]
      });
      var marker = L.marker({
        lon: el.longitude,
        lat: el.latitude
      }, {
        icon: markerIcon
      }); // marker.on('click', () => openDialog(el))

      marker.on('mouseover', function (e) {
        return e.target.openTooltip();
      });
      marker.on('mouseout', function (e) {
        return e.target.closeTooltip();
      }); // if(el.dataType !== 'event') {

      var tooltipIcon = renderMarkerTooltip(el);
      var tooltipOptions = {
        // permanent: true, // always open
        className: cx('its-tooltip', el.dataType),
        direction: 'bottom',
        offset: el.dataType === 'event' ? [2, 5] : [2, 0],
        opacity: 1
      };
      marker.bindTooltip(tooltipIcon, tooltipOptions); // }

      return marker;
    });

    markerClusterGroup.addLayers(newMarkers);
    markerClusterGroup.addTo(markersLayerGroup.current);
    markersLayerGroup.current.addTo(map);
    return function () {
      clearAllMarkers();
    };
  }, [JSON.stringify(markerList)]);
  return null;
});
export default MapAnalyticsMarkers;